import React, { useState, useEffect } from "react";
import { Skeleton, Row, Col } from "antd";
import { connect } from "react-redux";
// import { Jutsu } from 'react-jutsu' // Component
import _ from "lodash";
import moment from "moment";
/* custom component */
import { LayoutContainer, PageContainer } from "../../../component/Xcomponent";

import { JitsiMeeting } from "@jitsi/react-sdk";
import { JitsiMeet } from "./AppointmentMeetingStyle.js";

/* action */
import {
  getAppointmentDetail,
  getAppointmentDetailReset,
} from "../../../action/getAppointmentDetailAction";
import {
  bookedAppointmentActivity,
  bookedAppointmentReset,
} from "../../../action/bookedAppointmentActivity";

import { convertTZ, dateTimeUTCFormat, timeSlotFormat } from "../../../utils";
import { useHistory } from "react-router-dom";
import config from "../../../config";
import { getDoctorDetail } from "../../../action/getDoctorDetailAction";

const AppointmentMeeting = (props) => {
  /* variable */
  const {
    getAppointmentDetail,
    getAppointmentDetailReset,
    getAppointmentDetailState,
    bookedAppointmentActivity,
    bookedAppointmentReset,
    appointmentActivityState,
    getDoctorDetailState,
  } = props;

  const id = props.match.params.id;
  const [onCall, setOnCall] = useState(false);
  const [refresh, setRefresh] = useState(0);

  /* callbacks */
  useEffect(() => {
    return () => {
      getAppointmentDetailReset();
    };
  }, []);

  useEffect(() => {
    if (appointmentActivityState.apiState) {
      bookedAppointmentReset();
    }
  }, [appointmentActivityState]);

  let history = useHistory();

  useEffect(() => {
    if (getAppointmentDetailState.apiState === "success") {
      let date = moment(getAppointmentDetailState.data.date).utc().unix();
      let to_date = moment(getAppointmentDetailState.data.to_date).utc().unix();
      // let current_date = moment(new Date()).add(-2, 'minute').unix()
      let current_date = convertTZ(
        moment().add(-2, "minute").format("YYYY-MM-DD HH:mm:ss") + " +0000",
        "Asia/Kolkata"
      );
      current_date = moment(current_date).utc().unix();
      if (date <= current_date && to_date >= current_date) {
        setOnCall(true);
        bookedAppointmentActivity({
          book_appointment_id: id,
          activity_type: "joined",
        });
      } else {
        setInterval(() => setRefresh(refresh + 1), 5000);
      }
    }
  }, [getAppointmentDetailState, refresh]);

  useEffect(() => {
    if (id) {
      getAppointmentDetail({
        id: id,
      });
    }
  }, [id]);

  // Functions
  console.log(getAppointmentDetailState.data);
  return (
    <PageContainer>
      {getDoctorDetailState.apiState == "success" &&
      getDoctorDetailState.data.is_dcp_activated == "Yes" ? (
        <LayoutContainer>
          {getAppointmentDetailState.apiState === "loading" && (
            <Skeleton active />
          )}

          {getAppointmentDetailState.apiState === "error" && (
            <p>{getAppointmentDetailState.message}</p>
          )}

          {getAppointmentDetailState.apiState === "success" && (
            <>
              {!onCall && (
                <Row gutter={20}>
                  <Col span="12">
                    {" "}
                    Your meeting will start on{" "}
                    {dateTimeUTCFormat(getAppointmentDetailState.data.date)}
                  </Col>
                </Row>
              )}

              <Row gutter={22}>
                <Col xs={24} sm={24} md={22} lg={16} xl={16}>
                  {
                    onCall && (
                      <JitsiMeet>
                        <JitsiMeeting
                          domain={config.jitsi_meet_domian}
                          roomName={`${getAppointmentDetailState.data.room_id}`}
                          userInfo={{
                            displayName: `${getAppointmentDetailState.data.doctor_id.fname} ${getAppointmentDetailState.data.doctor_id.lname}`,
                          }}
                          configOverwrite={{
                            prejoinPageEnabled: false,
                            enableClosePage: false,
                            enableCalendarIntegration: false,
                            disablePolls: true,
                            welcomePage: {
                              disabled: true,
                            },
                            startWithVideoMuted: true,
                            startWithAudioMuted: true,
                            toolbarButtons: [
                              "camera",
                              "hangup",
                              "chat",
                              "microphone",
                            ],
                          }}
                          onReadyToClose={() => {
                            bookedAppointmentActivity({
                              book_appointment_id: id,
                              activity_type: "disconnected",
                            });
                            window.location.href = "/appointment";
                          }}
                          loadingComponent={<p> Your meeting is loading ...</p>}
                          subject={`Time Slot: ${timeSlotFormat(
                            getAppointmentDetailState.data.time_slot_start
                          )} - ${timeSlotFormat(
                            getAppointmentDetailState.data.time_slot_end
                          )}`}
                        />
                      </JitsiMeet>
                    )

                    // <Jutsu
                    //     // domain={`lilac-doctor-dev.aiolos.solutions`}
                    //     // jwt={`eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtNjU4YTY4NzNjODc2NDQ5NmE5MjI2ZWNmYTNmN2JmMDUvNjIzODhkLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImV4cCI6MTYzNDgxNTE4NywibmJmIjoxNjM0ODA3OTgyLCJpc3MiOiJjaGF0Iiwicm9vbSI6IioiLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtNjU4YTY4NzNjODc2NDQ5NmE5MjI2ZWNmYTNmN2JmMDUiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJtb2RlcmF0b3IiOnRydWUsIm5hbWUiOiJhc2hpc2giLCJpZCI6Imdvb2dsZS1vYXV0aDJ8MTEyNjgwNTUyMDcxNjQ3OTk4OTk4IiwiYXZhdGFyIjoiIiwiZW1haWwiOiJhc2hpc2hAYWlvbG9zLmNsb3VkIn19fQ.bpYaHDZxHJG8FG4OSUavqwWlebXZU7ynyK2GfOYP4LXHTnAN7ZTHMTkxn7TO7HpUEPUJWzYKytbTTn2IiVZHQkN9Qzi_DI1RDrmh6rfW8Lrz3j6sguSLz-p8ZZMXNLCI7jeaeeC_WEuRgd5HQHDfkHcNDGLBAvS7Vv9Z0V-qTHOy01SxRS5YZzRdWx50mEwbF18Ggt28VnEozhQKt8qZU1Bccjhy3QzGkJL1OtvdfHkKPNM9A3NLA1YJSOBZgr-_Nbx9oLKE0P_9W-fcKFJayrCkDFz7l9kLL5PiQStTRokaktDM-UiClu0mtJd52mYJmY0xdQ13uw7Hp_7om8lfIg`}
                    //     // roomName={`vpaas-magic-cookie-658a6873c8764496a9226ecfa3f7bf05/${getAppointmentDetailState.data.room_id}`}
                    //     roomName={`${getAppointmentDetailState.data.room_id}`}
                    //     onMeetingEnd={()=>bookedAppointmentActivity({book_appointment_id:id, activity_type:"disconnected"})}
                    //     displayName={`${getAppointmentDetailState.data.doctor_id.fname} ${getAppointmentDetailState.data.doctor_id.lname}`}
                    //     loadingComponent={<p> jitsi is loading ...</p>}
                    //     configOverwrite={{
                    //         prejoinPageEnabled: false,
                    //         enableCalendarIntegration: false,
                    //         disablePolls: true,
                    //         welcomePage:{
                    //             disabled:true,
                    //         },
                    //         toolbarButtons: [
                    //             'camera',
                    //             'hangup',
                    //             'chat',
                    //             'microphone',
                    //         ],
                    //     }}
                    //     subject={`Time Slot: ${timeSlotFormat(getAppointmentDetailState.data.time_slot_start)} - ${timeSlotFormat(getAppointmentDetailState.data.time_slot_end)}`}
                    // />
                  }
                </Col>
              </Row>
            </>
          )}
        </LayoutContainer>
      ) : (
        <h6>Access Not Authorized</h6>
      )}
    </PageContainer>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getAppointmentDetailState: state.getAppointmentDetail,
  appointmentActivityState: state.bookedAppointmentActivityState,
});

const mapDispatchToProps = (dispatch) => ({
  getAppointmentDetail: (params) => dispatch(getAppointmentDetail(params)),
  getAppointmentDetailReset: () => dispatch(getAppointmentDetailReset()),
  bookedAppointmentActivity: (params) =>
    dispatch(bookedAppointmentActivity(params)),
  bookedAppointmentReset: (params) => dispatch(bookedAppointmentReset(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentMeeting);
